import { useState } from 'react';
import { useLocation, useOutlet } from 'react-router-dom';
import { Box } from '../components';
import { AnimatePresence, motion } from 'framer-motion';

const AnimatedPageContainer = () => {
  const location = useLocation();
  const animationValues = {
    initial: {
      opacity: 0,
      position: 'relative',
    } as any,
    animate: {
      opacity: 1,
      position: 'relative',
    } as any,
    exit: {
      opacity: 0,
      position: 'absolute',
    } as any,
  };

  const AnimatedOutlet = () => {
    const o = useOutlet();
    const [outlet] = useState(o);

    return <>{outlet}</>;
  };

  return (
    <Box position="relative">
      <AnimatePresence>
        <motion.div
          variants={animationValues}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.6 }}
          key={location.pathname}
        >
          <AnimatedOutlet />
        </motion.div>
      </AnimatePresence>
    </Box>
  );
};

export default AnimatedPageContainer;
